"use client"

import { TextWrap } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TextWrapIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TextWrapIcon = component(Icon)({ as: TextWrap })
